
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caste-otazky",
      function () {
        return require("private-next-pages/caste-otazky.js");
      }
    ]);
  